import { ComponentProps } from "react";
import Disclaimer from "@features/taboola/components/Disclaimer/Disclaimer";
import Text from "@features/taboola/components/Disclaimer/Text";
import { cn } from "@util/helpers";

type DeeperdiveProps = {
  /** The URL path of the page. */
  urlPath: string;
  /** The counter of the Deeperdive component. */
  counter?: number;
  /** The className for disclaimer component. */
  disclaimerClassName?: string;
} & Pick<ComponentProps<typeof Text>, "isArticlePage">;

/**
 * The Deeperdive component.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=0-1&p=f&m=dev
 * */
const Deeperdive = ({
  urlPath,
  counter,
  isArticlePage = false,
  disclaimerClassName,
}: DeeperdiveProps): React.ReactElement => {
  const _counter = typeof counter === "number" ? `-${counter}` : "";

  return (
    <>
      <div
        data-testid="deeper-dive-component"
        id={`deeper-dive-container${_counter}`}
        className={cn("track-impression deeper-dive-container peer", {
          "md:px-8": isArticlePage,
        })}
        style={{ display: "none" }}
        aria-hidden="true"
        data-url={urlPath}
        data-section-name="deeperdive"
      ></div>

      <Disclaimer
        isArticlePage={isArticlePage}
        className={disclaimerClassName}
      />
    </>
  );
};

export default Deeperdive;
